import { render, staticRenderFns } from "./PromptGeneration.vue?vue&type=template&id=2b6eb6f8&"
import script from "./PromptGeneration.vue?vue&type=script&lang=js&"
export * from "./PromptGeneration.vue?vue&type=script&lang=js&"
import style0 from "./PromptGeneration.vue?vue&type=style&index=0&id=2b6eb6f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports